import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

const Navbar = ({ lang, setLang, t, scrollToSection, refs }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // 페이지 이동 후 스크롤 처리 로직
  const handleScroll = (targetRef, targetPage) => {
    if (location.pathname !== targetPage) {
      // 1. 페이지가 다르면 일단 페이지 이동
      navigate(targetPage);
      // 2. 페이지가 렌더링될 시간을 조금 준 뒤 스크롤 실행
      setTimeout(() => {
        scrollToSection(targetRef);
      }, 150);
    } else {
      // 3. 같은 페이지라면 즉시 스크롤
      scrollToSection(targetRef);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link
          to="/"
          className="logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <img
            src="/pak-logo.png"
            alt="TKA Logo"
            style={{ height: "120px", display: "block" }}
          />
        </Link>
        <ul className="nav-links">
          {/* 회사소개 드롭다운 */}
          <li className="nav-item-dropdown">
            <span
              className="nav-main-link"
              onClick={() => handleScroll(null, "/")}
            >
              {t.navAbout} {/* 변수 처리 */}
            </span>
            <ul className="dropdown-menu">
              <li onClick={() => handleScroll(refs.bizRef, "/")}>
                {t.aboutTitle1}
              </li>
              <li onClick={() => handleScroll(refs.historyRef, "/")}>
                {t.aboutTitle2}
              </li>
              <li onClick={() => handleScroll(refs.clientRef, "/")}>
                {t.clientTitle}
              </li>
              <li onClick={() => handleScroll(refs.mapRef, "/")}>
                {t.mapTitle || "Location"}
              </li>
            </ul>
          </li>

          {/* PCB 가이드 드롭다운 */}
          <li className="nav-item-dropdown">
            <span
              className="nav-main-link"
              onClick={() => handleScroll(null, "/PCBGuide")}
            >
              {t.navPcbGuide} {/* 변수 처리 */}
            </span>
            <ul className="dropdown-menu">
              <li onClick={() => handleScroll(refs.pcbRef, "/PCBGuide")}>
                {t.menuPcbIntro} {/* 변수 처리 */}
              </li>
              <li onClick={() => handleScroll(refs.priceRef, "/PCBGuide")}>
                {t.menuPcbProcess} {/* 변수 처리 */}
              </li>
              <li onClick={() => handleScroll(refs.deliveryRef, "/PCBGuide")}>
                {t.menuPcbTypes} {/* 변수 처리 */}
              </li>
            </ul>
          </li>

          <li>
            <a href="mailto:tiger@tripod-korea.com" className="nav-mail-link">
              {t.navContact} {/* 변수 처리 */}
            </a>
          </li>
        </ul>

        <div className="lang-selector">
          <span
            className={lang === "ko" ? "active" : "inactive"}
            onClick={() => setLang("ko")}
          >
            KOR
          </span>
          {" | "}
          <span
            className={lang === "en" ? "active" : "inactive"}
            onClick={() => setLang("en")}
          >
            ENG
          </span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
